export default function initPostInfoTextWrapp() {
	jQuery('.js-break-text').each((i, text) => {
		const parent = text.parentNode;
		const resizeObserver = new ResizeObserver(resizeHandler);
		const breakClass = 'mobile-reverse';
		let resizeTimer = null;

		function resizeHandler() {
			clearTimeout(resizeTimer);

			resizeTimer = setTimeout(() => {
				parent.classList.remove(breakClass);
				parent.style.position = 'relative';

				if (text.offsetLeft < 10) {
					parent.classList.add(breakClass);
				}

				parent.style.position = '';
			}, 100);
		}

		resizeObserver.observe(parent);
	});
}